var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "modal-card modal-card--modern modal-card--md" },
    [
      _c("div", { staticClass: "auth-modal-wrapper" }, [
        _c("header", { staticClass: "modal-card-head" }, [
          _c("p", { staticClass: "modal-card-title" }, [_vm._v(" Sign In ")]),
          _c(
            "a",
            {
              staticClass: "close-modal",
              attrs: { "aria-label": "close" },
              on: {
                click: function ($event) {
                  return _vm.closeModal()
                },
              },
            },
            [_c("i", { staticClass: "material-icons" }, [_vm._v("close")])]
          ),
        ]),
        _c("section", { staticClass: "modal-card-body" }, [
          _c("p", [
            _vm._v(" To continue, please enter your company email address "),
          ]),
          _c(
            "div",
            {
              staticClass: "input-container with-left-icon",
              class: { "input-container--error": _vm.error },
            },
            [
              _c("span", { staticClass: "icon icon-email-action-unread" }),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.email,
                    expression: "email",
                  },
                ],
                attrs: {
                  type: "email",
                  autocomplete: "email",
                  placeholder: "name@example.com",
                },
                domProps: { value: _vm.email },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.email = $event.target.value
                  },
                },
              }),
            ]
          ),
          _vm.error
            ? _c(
                "span",
                {
                  staticClass:
                    "error-message is-small-text error-message--after-input-container",
                },
                [_vm._v(" " + _vm._s(_vm.error) + " ")]
              )
            : _vm._e(),
          _c("div", { staticClass: "flexbox-center button-row" }, [
            _c(
              "button",
              {
                staticClass: "button button-medium button-secondary",
                on: {
                  click: function ($event) {
                    return _vm.next()
                  },
                },
              },
              [
                _vm.emailLoading
                  ? _c("div", { staticClass: "labs-loader" })
                  : _vm._e(),
                _vm._v(" Next "),
              ]
            ),
          ]),
          _c("div", { staticClass: "modal-footer-note is-small-text" }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }